import type { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { RouteResource } from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import UsageViewAnalyticsActivationQuery, {
	type UsageViewAnalyticsActivationQuery as UsageViewAnalyticsActivationQueryType,
} from '../components/__generated__/UsageViewAnalyticsActivationQuery.graphql';

/**
 * Preloads the site's Analytics activation during the route transition. The view reads it
 * with the same variables via useLazyLoadQuery, which reuses this request, then loads the
 * template for the selected tab from that workspace.
 */
export const usageActivationResource: RouteResource<
	PreloadedQuery<UsageViewAnalyticsActivationQueryType, Record<string, unknown>>
> = createRelayResource<UsageViewAnalyticsActivationQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const cloudId = (resourceContext as HomeResourceContext).collabContext?.cloudId;

		return {
			environment: getAggRelayEnvironment(),
			query: UsageViewAnalyticsActivationQuery,
			variables: {
				cloudId: cloudId ?? '',
				isEnabled: !!cloudId && fg('townsquare_home_usage_page'),
			},
			options: { fetchPolicy: 'store-or-network' },
		};
	},
});
